import React from 'react';
import {
  Table,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { roleUrl } from '@/constants/urls';
import SimpleCell from '@/components/table/SimpleCell';
import UserRoleFilter from './UserRoleFilter';

const UserRoleCell = ({
  category,
  role,
  updateFilterRole,
  roleName,
  asLink,
  roleFilter = true,
}) => {
  const name = role ? role.name : '';

  if (!asLink || !hasMinimumLength(name)) {
    return (<SimpleCell content={name} />);
  }

  return (
    <Table.Cell>
      {roleFilter && (
        <UserRoleFilter
          name={name}
          category={category}
          onClick={(value) => updateFilterRole(category, value)}
          matches={name === roleName}
          floated="right"
        />
      )}
      <Link to={roleUrl(role)} title={name}>
        {name}
      </Link>
    </Table.Cell>
  );
};

export default UserRoleCell;
